import React, { useEffect } from 'react'
import DataItem from './DataItem'
import { create } from 'zustand'
import Checkbox from 'components/ui/MyCheckbox'
import { Card, CardContent } from '@/components/ui/card'

export const useCardAtom = create((set) => ({
  info: true,
  badge: true,
  header: true,
  reportCount: false,
  toggleInfo: () => set((state) => ({ info: !state.info })),
  toggleBadge: () => set((state) => ({ badge: !state.badge })),
  toggleHeader: () => set((state) => ({ header: !state.header })),
  toggleReportCount: () =>
    set((state) => ({ reportCount: !state.reportCount })),
  setShowReportCount: (value) => set(() => ({ reportCount: Boolean(value) })),
}))

function DisplayData({
  data,
  mutate,
  defaultShowReportCount,
  cardWrapperClassName,
  fillContainer = false,
  onAuthorClick,
}) {
  const setShowReportCount = useCardAtom((state) => state.setShowReportCount)
  useEffect(() => {
    if (defaultShowReportCount) {
      setShowReportCount(defaultShowReportCount)
    }
  }, [defaultShowReportCount, setShowReportCount])

  const wrapperClassName = cardWrapperClassName
    ? cardWrapperClassName
    : fillContainer
      ? 'min-h-0 flex-1'
      : '!h-[calc(100vh-306px)]'

  return (
    <div
      className={
        fillContainer
          ? 'flex h-full min-h-0 flex-col pt-2'
          : 'flex flex-col pt-2'
      }
    >
      <div className="mb-4 flex flex-shrink-0 items-center gap-4">
        <ToggleHeader />
        <ToggleBadge />
        <ToggleInfo />
        <ToggleReportCount />
      </div>
      <div className={wrapperClassName}>
        <Card className="flex h-full flex-col">
          <CardContent className="min-h-0 flex-1 overflow-hidden pb-0 pl-6 pr-0">
            <div className="h-full overflow-auto">
              <div className="my-6 mr-6 grid grid-cols-9 gap-2 lg:grid-cols-6 xl:grid-cols-9">
                {data?.map((item, index) => (
                  <DataItem
                    data={item}
                    key={item.id}
                    index={index}
                    mutate={mutate}
                    onAuthorClick={onAuthorClick}
                  />
                ))}
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

const ToggleHeader = () => {
  const header = useCardAtom((state) => state.header)
  const toggle = useCardAtom((state) => state.toggleHeader)
  return (
    <Checkbox checked={header} onCheckedChange={toggle} label={'show header'} />
  )
}

const ToggleBadge = () => {
  const badge = useCardAtom((state) => state.badge)
  const toggle = useCardAtom((state) => state.toggleBadge)
  return (
    <Checkbox
      checked={badge}
      onCheckedChange={toggle}
      label={'show badge'}
    ></Checkbox>
  )
}

const ToggleInfo = () => {
  const info = useCardAtom((state) => state.info)
  const toggleInfo = useCardAtom((state) => state.toggleInfo)
  return (
    <Checkbox
      checked={info}
      onCheckedChange={toggleInfo}
      label={'show info'}
    ></Checkbox>
  )
}

const ToggleReportCount = () => {
  const reportCount = useCardAtom((state) => state.reportCount)
  const toggleReportCount = useCardAtom((state) => state.toggleReportCount)
  return (
    <Checkbox
      checked={reportCount}
      onCheckedChange={toggleReportCount}
      label={'show report count'}
    />
  )
}

export default DisplayData
